import homePage from '../components/Home.vue'

export const routes = [
    {
      path: '/',
      name: 'index',
      component: homePage,
      props: route => ({ 
                        propChId: route.query.channelId ? parseInt(route.query.channelId):-1,
                        propChName: route.query.channelName ? route.query.channelName:'',
                        propFilters: route.query.filters ? JSON.parse(JSON.parse(route.query.filters)):[],
                        propSecondScreen: route.query.secondScreen ? route.query.secondScreen:false,
                       })
      // props: route => ({ channelId: parseInt(route.query.channelId),
      //                    filtersOptions: JSON.parse(route.query.filtersOptions)
      //                  })
      // meta: { title: `${DOMAIN_TITLE} | home` }
    },
]